<template src="./template.html"></template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'PurchaseSummary',
  props: {
    props: Object,
  },
  computed: {
    ...mapState('settings', [
      'settings',
      'pendingSettings',
    ]),
    ...mapState('summary', [ 'coinPacksOnly' ]),
    isVirtualCurrency() {
      return !this.pendingSettings &&
             this.settings.active_features &&
             this.settings.active_features.use_virtual_currency &&
             !this.coinPacksOnly
    },
  },
  created() {
    this.getSettings()
  },
  methods: {
    ...mapActions('settings', [ 'getSettings' ]),
  },
}
</script>
